/* prettier-ignore */

import { inject, Injectable, signal } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { RestService } from '../../services/rest.service';
import { StatisticsService } from '../../services/statistics.service';
import { LoginResponse, LoginResponseError } from '../interfaces';
import { TranslateService } from '@ngx-translate/core';
import { ModalController } from '@ionic/angular';
import { LocalStorageService, Snackbar } from 'src/app/services';
import { UserUpdatedResponse } from 'src/app/user/interfaces';

@Injectable({ providedIn: 'root' })
export class AuthService {
  private _translateService = inject(TranslateService);
  private _router = inject(Router);
  private _http = inject(HttpClient);
  private _restService = inject(RestService);
  private _statisticsService = inject(StatisticsService);
  private _snackbarService = inject(Snackbar);
  private _localStorageService = inject(LocalStorageService); // TODO: DELETE FOR SSR -> NEW LOGIN STRATEGY (SECURE COOKIE)
  private _modalCtrl = inject(ModalController); // TODO: DELETE FOR SSR -> DIALOG MATERIAL ANGULAR/DS
  
  private _user = signal<UserUpdatedResponse | null>(null);
  public user = this._user.asReadonly();
  
  private _isUserLoggedOut = signal<boolean>(false);
  public isUserLoggedOut = this._isUserLoggedOut.asReadonly();
  
  public setUser(user: UserUpdatedResponse | null) {
    this._user.set(user);
  }
  
  public setIsUserLoggedOut(isLoggedOut: boolean) {
    this._isUserLoggedOut.set(isLoggedOut);
  }
  
  public updateUserByNameAndBirthDate(name: string, date_of_birth: string): void {
    this._user.update((currentUser) => {
      if (currentUser) {
        return { 
          ...currentUser, 
          name: name, 
          date_of_birth: date_of_birth 
        };
      }
      return currentUser;
    });
  }
  
  public loginServiceSignal(email: string, password: string): void {
    this._login(email, password)
      .subscribe({
        next: (response: LoginResponse) => {
          this._user.set(response.data.user);
          this._localStorageService.setItem('loginResponse', response, 2 * 3600); // TODO: DELETE FOR SSR -> NEW LOGIN STRATEGY (SECURE COOKIE)
          this._localStorageService.setItem('user', response.data.user, 2 * 3600); // TODO: REMOVE LATER
          this._statisticsService.login = response.data.user.email; // TODO: REVIEW FOR SSR
          
          const successMessage = this._translateService.instant('Inicio de sesión exitoso');
          this._snackbarService.showSuccessSnackbar(successMessage);
          this.dismissModal();
        },
        error: (error: LoginResponseError) => {
          this._snackbarService.showErrorSnackbar(error.message);
        }
      });
  }
  
  private _login(email: string, password: string): Observable<LoginResponse> {
    const payload = { email, password }
    return this._http.post(`${this._restService.apiUrlBase}/api/webapp-login`, payload)
      .pipe(
        catchError((error) => {
          return throwError(() => error.error);
        }),
        map((response: LoginResponse) => {
          this._isUserLoggedOut.set(false);
          return response;
        }
    ));
  }

  public logout() {
    this._statisticsService.login = '';
    this._localStorageService.removeItem('user'); // TODO: DELETE FOR SSR -> NEW LOGIN STRATEGY (SECURE COOKIE)
    this._isUserLoggedOut.set(true);
    this._user.set(null);
    this._router.navigateByUrl('/home');
  }

  public customLogOut(){
      this._localStorageService.removeItem('user'); // TODO: DELETE FOR SSR -> NEW LOGIN STRATEGY (SECURE COOKIE)
      this._user.set(null);
  }

  public register(email: string, password: string) {
    const payload = { email, password }
    return this._http.post(`${this._restService.apiUrlBase}/api/send-register`, payload)
  }
  
  dismissModal(){
    this._modalCtrl.dismiss().catch(e => {
      console.warn("No modal found on dismiss")
    });
  }
}